import { Node_Type } from "./../ricos-types";
import { getCurrentHeadingIcon } from "./../toolbars-modals/lib/getCurrentHeadingIcon";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { TEXT_BUTTON_HEADINGS } from "./data-hooks";
import HeadingPanelComponent from "./HeadingsPanelComponent";
const HEADINGS_MODAL_ID = `${Node_Type.HEADING}.modal`;
const getHeadingsIcon = (isCustomHeadings) => {
  return getCurrentHeadingIcon(isCustomHeadings);
};
const getTextButtons = (config) => {
  const isCustomHeadings = !!config?.allowHeadingCustomization;
  return [
    {
      id: `${Node_Type.HEADING}.dropdown`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_HEADINGS,
        tooltip: "FormattingToolbar_TextStyleButton_Tooltip",
        getIcon: getHeadingsIcon(isCustomHeadings)
      },
      attributes: {
        isStylesMatch: RESOLVERS_IDS.IS_TEXT_STYLES_MATCH_DOCUMENT_STYLES,
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedHeading: RESOLVERS_IDS.GET_HEADING_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_OR_CAPTION_SELECTED
      },
      modal: {
        id: HEADINGS_MODAL_ID,
        Component: HeadingPanelComponent(isCustomHeadings ? 230 : 143)
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
